import { Container, Mesh, Program, BoxGeometryBuffer, IcoSphereGeometryBuffer } from 'beam';
import gridVertexShader from './shaders/grid-vs.glsl'
import gridFragmentShader from './shaders/grid-fs.glsl'
import Tween from './helpers/Tween';
import CubicBezier from './helpers/cubicBezier';
import SpeedEffect from './SpeedEffect';
import Emitter from '../core/emitter.js'

export default class GLWelcomeScreen extends HTMLElement {

    constructor() {
        super();
        this.resize        = this.resize.bind(this);
        this.update        = this.update.bind(this);
        this.onTransitionLeave = this.onTransitionLeave.bind(this);
        this.leaveProgress = 0;
    }

    onTransitionLeave() {
        this.leaveProgress = 1;
    }

    connectedCallback() {
        this.__isConnected__ = true;

        let node = this;
        let i=0;
        while (node.parentNode && i<100) { 
            if (node.parentNode.tagName == 'WEBGL-SCENE') {
                this.$glScene = node.parentNode;
                break;
            }
            node = node.parentNode;
            i++;
        }

        if (!this.$glScene) {
            console.warn('missing <gl-scene> parent node');
            return
        }

        requestAnimationFrame(()=>{
            this.init();
            this.update();
            this.show();

            Emitter.on('transition:leave', this.onTransitionLeave);
        })
    }

    init() {

        this.renderer = this.$glScene.renderer;
        
        this.container = new Container();
        this.$glScene.addChild(this.container);

        this.speedEffect = new SpeedEffect(this.renderer);
        this.container.add(this.speedEffect.container);

        this.gridScale                     = 1;
        this.gridIntroScale                = 0.15;
        this.gridRawScale                  = 0;
        this.gridBackgroundIntroPointScale = 1;
        this.easedGridScale                = 0;
        this.easedGridIntroScale           = 0;
        this.easedGridRawScale             = 0;

        const gridMesh = new Mesh();
        gridMesh.geometry = new BoxGeometryBuffer(this.renderer.gl, {
            width:  200 * 0.8, 
            height: 200 * 0.8, 
            depth:  400 * 0.8,
            widthSegments:  1,
            heightSegments: 1,
            depthSegments:  1,
        });
        gridMesh.material = new Program(this.renderer.gl, {
            blend:          true,
            vertexShader:   gridVertexShader,
            fragmentShader: gridFragmentShader,
            type:           this.renderer.gl.POINTS,
            uniforms: {
                uPointScale: 1,
                uGridLogo: 1,
            }
        });
        this.gridMesh = gridMesh;
        this.container.add(this.gridMesh);

        const gridMeshFull = new Mesh();
        gridMeshFull.geometry = new BoxGeometryBuffer(this.renderer.gl, {
            width:  200 * 0.8, 
            height: 200 * 0.8, 
            depth:  400 * 0.8,
            widthSegments:  1,
            heightSegments: 1,
            depthSegments:  4,
        });
        gridMeshFull.material = new Program(this.renderer.gl, {
            blend:          true,
            vertexShader:   gridVertexShader,
            fragmentShader: gridFragmentShader,
            type:           this.renderer.gl.POINTS,
            uniforms: {
                uPointScale: 0,
                uGridFull: 1,
            }
        });
        this.gridMeshFull = gridMeshFull;
        this.container.add(this.gridMeshFull);


        const gridMeshLarger = new Mesh();
        gridMeshLarger.geometry = new BoxGeometryBuffer(this.renderer.gl, {
            width:  300 * 0.8, 
            height: 200 * 0.8, 
            depth:  230 * 0.8,
            widthSegments:  8,
            heightSegments: 1,
            depthSegments:  4,
        });
        gridMeshLarger.material = new Program(this.renderer.gl, {
            blend:          true,
            vertexShader:   gridVertexShader,
            fragmentShader: gridFragmentShader,
            type:           this.renderer.gl.POINTS,
            uniforms: {
                uRandom: 1,
                uPointScale: 1,
                uGridLarger: 1,
            }
            // wireframe:      true,
        });
        gridMeshLarger.position[2] = -200;

        this['gridMeshLarger'] = gridMeshLarger;
        this.container.add(this['gridMeshLarger']);


        const icoSphere = new Mesh();
        icoSphere.geometry = new IcoSphereGeometryBuffer(this.renderer.gl, {
            radius:         2000, 
            details:        8,
        });
        icoSphere.material = new Program(this.renderer.gl, {
            vertexShader:   gridVertexShader,
            fragmentShader: gridFragmentShader,
            type:           this.renderer.gl.POINTS,
            uniforms: {
                uPointScale:   0.6,
                uInfiniteGrid: 0,
                uIntroBackground: 1
            }
        });
        this.icoSphere = icoSphere;
        this.container.add(icoSphere);


        

    }

    show() {
        this.gridIntroScale = ( ( 0. ) )  ;
        // Tween({e:0}, {
        //     to: {e:1},
        //     easing:  [0.430, 0.195, 0.020, 1.000],
        //     duration: 0.8,
        //     step: e => {
        //         this.gridIntroScale = ( ( 0.11 + e * 0.04) )  ;
        //     },
        //     end: () => {

        //         Tween({e:0}, {
        //             to: {e:1},
        //             easing:  [0.430, 0.195, 0.020, 1.000],
        //             duration: 1,
        //             step: e => {
        //                 this.gridIntroScale = ( ( 0.15 - e * 0.07) )  ;
        //             },
        //             end: () => {
                        Tween({e:0}, {
                            to: {e:1},
                            delay: 0, 
                            easing:  [0.690, 0.000, 0.090, 1.000],
                            duration: 2,
                            step: e => {
                                this.gridIntroScale = ( 0. + ( e * 0.9) )  ;
                            },
                        });
                    // }
                // });
            // }
        // });

       
    }

    update() {

        if (!this.__isConnected__) {
            return;
        }

        requestAnimationFrame(()=>{
            this.update();
        });


        const progress      = Math.max(0, Math.min(1, this.$glScene._scroll / (window.innerHeight)));
        // const easedProgress = CubicBezier( 0.775, 0.065, 0.345, 0.880, progress, 1 );
        const easedProgress = CubicBezier( 0.775, 0.065, 0.345, 0.880, progress, 1 );
        const e = easedProgress;


        this.gridScale    = ( ( 1 +  e * 2.5) )   ;
        this.gridRawScale = e;

        this.easedGridScale       += ((this.gridScale )      - this.easedGridScale)      * 0.1 ;
        this.easedGridIntroScale  += (( this.gridIntroScale) - this.easedGridIntroScale) * 0.1 ;
        this.easedGridRawScale    += ((this.gridRawScale )   - this.easedGridRawScale)   * 0.1 ;

        this.gridMesh.scale[0]    = (window.innerHeight * 0.45 * this.easedGridScale*this.easedGridIntroScale) / 200;
        this.gridMesh.scale[1]    = (window.innerHeight * 0.45 * this.easedGridScale*this.easedGridIntroScale) / 200;
        this.gridMesh.scale[2]    = (window.innerHeight * 0.45 * (1.5 - .2 * this.easedGridIntroScale) * this.easedGridScale) / 200;
        this.gridMesh.position[2] = -500;
        this.gridMesh.material.uniforms.uPointScale.value =  (1. - this.leaveProgress) * (1 - this.easedGridRawScale) * (1+0.5-this.easedGridIntroScale*0.5)  * (window.innerHeight/900)

        this.gridMeshFull.scale[0]    = (window.innerHeight * 0.45 * this.easedGridScale*this.easedGridIntroScale) / 200;
        this.gridMeshFull.scale[1]    = (window.innerHeight * 0.45 * this.easedGridScale*this.easedGridIntroScale) / 200;
        this.gridMeshFull.scale[2]    = (window.innerHeight * 0.45 * (1.5 - .2 * this.easedGridIntroScale) * this.easedGridScale) / 200;
        this.gridMeshFull.position[2] = -500;
        this.gridMeshFull.material.uniforms.uPointScale.value =  (1. - this.leaveProgress) * (window.innerWidth < 600 ? 1 : 1.4) * this.gridBackgroundIntroPointScale   * ( this.easedGridIntroScale )  * (1 - this.easedGridRawScale)  * (window.innerHeight/900);

        this.gridMeshLarger.scale[0]  = (window.innerHeight * 0.5 * 1 * this.easedGridScale*this.easedGridIntroScale) / 200;
        this.gridMeshLarger.scale[1]  = (window.innerHeight * 0.5 * 1 * this.easedGridScale*this.easedGridIntroScale) / 200;
        this.gridMeshLarger.scale[2]  = (window.innerHeight * 0.5 * 2 * this.easedGridScale*this.easedGridIntroScale) / 200;
        this.gridMeshLarger.material.uniforms.uPointScale.value =  (1. - this.leaveProgress) * this.gridBackgroundIntroPointScale   * this.easedGridIntroScale  * (1 - this.easedGridRawScale) * (window.innerHeight/900)
        this.gridMeshLarger.position[2] = -300;

        this.speedEffect.update(this.$glScene._scroll, this.$glScene.camera);

        this.icoSphere.scale[0]  = (this.easedGridScale*this.easedGridIntroScale) * (window.innerWidth < 600 ? 0.2: 0.3);
        this.icoSphere.scale[1]  = (this.easedGridScale*this.easedGridIntroScale) * (window.innerWidth < 600 ? 0.2: 0.3);
        this.icoSphere.scale[2]  = (this.easedGridScale*this.easedGridIntroScale) * (window.innerWidth < 600 ? 0.2: 0.3);

        this.icoSphere.material.uniforms.uPointScale.value =  (1. - this.leaveProgress) * this.gridBackgroundIntroPointScale   * this.easedGridIntroScale  * (1 - this.easedGridRawScale) * 0.6  * (window.innerHeight/900)

    }

    disconnectedCallback() {
        console.log('<welcome-screen> disconnectedCallback()')
        this.__isConnected__ = false;
        window.removeEventListener('resize', this.resize);
        this.$glScene.removeChild( this.container )
        Emitter.off('transition:leave', this.onTransitionLeave);
    }

    resize() {
        const width  = window.innerWidth  || 1;
        const height = window.innerHeight || 1;
    }

   

}



customElements.define('gl-welcome-screen', GLWelcomeScreen)